import { Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import { I18N_COMPONENTS } from '../constants';

export function RemovePriceModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      primaryAction={{
        text: t(`${I18N_COMPONENTS}.remove_price_modal.confirm`),
        onClick: onConfirm,
        danger: true,
        loading,
      }}
      secondaryAction={{ text: t('buttons:cancel'), onClick: onClose }}
    >
      <Modal.Header>{t(`${I18N_COMPONENTS}.remove_price_modal.title`)}</Modal.Header>
      <Modal.Body>
        <Text variant="secondary" size="md">
          {t(`${I18N_COMPONENTS}.remove_price_modal.message`)}
        </Text>
      </Modal.Body>
    </Modal>
  );
}
